import styled, { css } from "styled-components";

interface StyledSearchListFormProps {
  $size: "large" | "medium" | "small";
  $focused: boolean;
  $disabled: boolean;
}

export const StyledSearchListForm = styled.div<StyledSearchListFormProps>`
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 0.4rem;
  padding: ${({ $size }) => ($size === "large" ? "0.8rem" : "0.4rem 0.8rem")};
  width: 100%;
  height: max-content;
  background-color: var(--bg-gray-normal);
  cursor: pointer;
  & > .indent-box {
    width: 0.4rem;
    height: 0.4rem;
    display: block;
  }
  & > .label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--text-gray-strong);
    font: ${({ $size }) =>
      $size === "large"
        ? "var(--body-medium-400)"
        : $size === "medium"
        ? "var(--body-small-400)"
        : "var(--label-small-400)"};
  }
  &:hover {
    background-color: var(--hovered);
  }
  ${({ $focused }) =>
    $focused &&
    css`
      background-color: var(--sec-orange-0);
      &:hover {
        background: linear-gradient(
            0deg,
            var(--hovered, rgba(121, 137, 165, 0.24)) 0%,
            var(--hovered, rgba(121, 137, 165, 0.24)) 100%
          ),
          var(--sec-orange-0, #ffebdd);
      }
    `}
  ${({ $disabled }) =>
    $disabled &&
    css`
      pointer-events: none;
      cursor: default;
      background-color: var(--bg-gray-normal);
      & > .label {
        color: var(--bg-gray-2);
      }
    `}
`;
